module.exports = __webpack_public_path__ + "img/page-title.e5ed6910.jpg";